import React, { Fragment } from "react";
import { Colxx, Separator } from "Components/CustomBootstrap";
import BreadcrumbContainer from "Components/BreadcrumbContainer";
import IntlMessages from "Util/IntlMessages";
import {
  Row,
  Card,
  CardBody,
  Pagination,
  PaginationItem,
  PaginationLink
} from "reactstrap";
import Fullscreen from "Components/Fullscreen";

function pagination() {
    return (
      <Fragment>
        <Row>
          <Colxx xxs="12">
            <BreadcrumbContainer
              heading={<IntlMessages id="menu.pagination" />}
            />
            <div className="float-right">
              <Fullscreen />
            </div>
            <Separator className="mb-5" />
          </Colxx>
        </Row>

        {/* pagination */}
        <Row>
          <Colxx xl="12" className="pl-0 pr-0 mb-5">
            <div className="pr-3 pl-3">
              <Card>
                <div>
                  <CardBody>
                    <Pagination aria-label="Page navigation example">
                      <PaginationItem>
                        <PaginationLink className="fa fa-angle-left" href="#" />
                      </PaginationItem>
                      <PaginationItem>
                        <PaginationLink
                          className="fa fa-angle-double-left"
                          href="#"
                        />
                      </PaginationItem>
                      <PaginationItem>
                        <PaginationLink href="#">1</PaginationLink>
                      </PaginationItem>
                      <PaginationItem>
                        <PaginationLink href="#">2</PaginationLink>
                      </PaginationItem>
                      <PaginationItem>
                        <PaginationLink href="#">3</PaginationLink>
                      </PaginationItem>
                      <PaginationItem>
                        <PaginationLink href="#">4</PaginationLink>
                      </PaginationItem>
                      <PaginationItem>
                        <PaginationLink href="#">5</PaginationLink>
                      </PaginationItem>
                      <PaginationItem>
                        <PaginationLink
                          className="fa fa-angle-right"
                          href="#"
                        />
                      </PaginationItem>
                      <PaginationItem>
                        <PaginationLink
                          className="fa fa-angle-double-right"
                          href="#"
                        />
                      </PaginationItem>
                    </Pagination>
                  </CardBody>
                </div>
              </Card>
            </div>
          </Colxx>
        </Row>
        {/* pagination Ends Here */}

        {/* pagination */}
        <Row>
          <Colxx xl="12" className="pl-0 pr-0 mb-5">
            <div className="pr-3 pl-3">
              <Card>
                <div>
                  <CardBody>
                    <Pagination aria-label="Page navigation example">
                      <PaginationItem>
                        <PaginationLink className="fa fa-angle-left" href="#" />
                      </PaginationItem>
                      <PaginationItem>
                        <PaginationLink
                          className="fa fa-angle-double-left"
                          href="#"
                        />
                      </PaginationItem>
                      <PaginationItem>
                        <PaginationLink href="#">1</PaginationLink>
                      </PaginationItem>
                      <PaginationItem>
                        <PaginationLink href="#">2</PaginationLink>
                      </PaginationItem>
                      <PaginationItem>
                        <PaginationLink href="#">3</PaginationLink>
                      </PaginationItem>
                      <PaginationItem>
                        <PaginationLink href="#">4</PaginationLink>
                      </PaginationItem>
                      <PaginationItem>
                        <PaginationLink href="#">5</PaginationLink>
                      </PaginationItem>
                      <PaginationItem>
                        <PaginationLink
                          className="fa fa-angle-right"
                          href="#"
                        />
                      </PaginationItem>
                      <PaginationItem>
                        <PaginationLink
                          className="fa fa-angle-double-right"
                          href="#"
                        />
                      </PaginationItem>
                    </Pagination>
                  </CardBody>
                </div>
              </Card>
            </div>
          </Colxx>
        </Row>
        {/* pagination Ends Here */}

        {/* pagination */}
        <Row>
          <Colxx xl="12" className="pl-0 pr-0 mb-5">
            <div className="pr-3 pl-3">
              <Card>
                <div>
                  <CardBody>
                    <Pagination aria-label="Page navigation example">
                      <PaginationItem>
                        <PaginationLink className="px-2" href="#">
                          {" "}
                          Previous{" "}
                        </PaginationLink>
                      </PaginationItem>
                      <PaginationItem>
                        <PaginationLink href="#">1</PaginationLink>
                      </PaginationItem>
                      <PaginationItem>
                        <PaginationLink href="#">2</PaginationLink>
                      </PaginationItem>
                      <PaginationItem>
                        <PaginationLink href="#">3</PaginationLink>
                      </PaginationItem>
                      <PaginationItem>
                        <PaginationLink href="#">4</PaginationLink>
                      </PaginationItem>
                      <PaginationItem>
                        <PaginationLink href="#">5</PaginationLink>
                      </PaginationItem>
                      <PaginationItem>
                        <PaginationLink className="px-2" href="#">
                          {" "}
                          Next{" "}
                        </PaginationLink>
                      </PaginationItem>
                    </Pagination>
                  </CardBody>
                </div>
              </Card>
            </div>
          </Colxx>
        </Row>
        {/* pagination Ends Here */}

        {/* pagination */}
        <Row>
          <Colxx xl="12" className="pl-0 pr-0 mb-5">
            <div className="pr-3 pl-3">
              <Card>
                <div>
                  <CardBody>
                    <Pagination size="lg" aria-label="Page navigation example">
                      <PaginationItem>
                        <PaginationLink className="fa fa-angle-left" href="#" />
                      </PaginationItem>
                      <PaginationItem>
                        <PaginationLink
                          className="fa fa-angle-double-left"
                          href="#"
                        />
                      </PaginationItem>
                      <PaginationItem>
                        <PaginationLink href="#">1</PaginationLink>
                      </PaginationItem>
                      <PaginationItem>
                        <PaginationLink href="#">2</PaginationLink>
                      </PaginationItem>
                      <PaginationItem>
                        <PaginationLink href="#">3</PaginationLink>
                      </PaginationItem>
                      <PaginationItem>
                        <PaginationLink href="#">4</PaginationLink>
                      </PaginationItem>
                      <PaginationItem>
                        <PaginationLink href="#">5</PaginationLink>
                      </PaginationItem>
                      <PaginationItem>
                        <PaginationLink
                          className="fa fa-angle-right"
                          href="#"
                        />
                      </PaginationItem>
                      <PaginationItem>
                        <PaginationLink
                          className="fa fa-angle-double-right"
                          href="#"
                        />
                      </PaginationItem>
                    </Pagination>
                  </CardBody>
                </div>
              </Card>
            </div>
          </Colxx>
        </Row>
        {/* pagination Ends Here */}

        {/* pagination */}
        <Row>
          <Colxx xl="12" className="pl-0 pr-0 mb-5">
            <div className="pr-3 pl-3">
              <Card>
                <div>
                  <CardBody>
                    <Pagination size="sm" aria-label="Page navigation example">
                      <PaginationItem>
                        <PaginationLink className="fa fa-angle-left" href="#" />
                      </PaginationItem>
                      <PaginationItem>
                        <PaginationLink
                          className="fa fa-angle-double-left"
                          href="#"
                        />
                      </PaginationItem>
                      <PaginationItem>
                        <PaginationLink href="#">1</PaginationLink>
                      </PaginationItem>
                      <PaginationItem>
                        <PaginationLink href="#">2</PaginationLink>
                      </PaginationItem>
                      <PaginationItem>
                        <PaginationLink href="#">3</PaginationLink>
                      </PaginationItem>
                      <PaginationItem>
                        <PaginationLink href="#">4</PaginationLink>
                      </PaginationItem>
                      <PaginationItem>
                        <PaginationLink href="#">5</PaginationLink>
                      </PaginationItem>
                      <PaginationItem>
                        <PaginationLink
                          className="fa fa-angle-right"
                          href="#"
                        />
                      </PaginationItem>
                      <PaginationItem>
                        <PaginationLink
                          className="fa fa-angle-double-right"
                          href="#"
                        />
                      </PaginationItem>
                    </Pagination>
                  </CardBody>
                </div>
              </Card>
            </div>
          </Colxx>
        </Row>
        {/* pagination Ends Here */}
      </Fragment>
    );
}

export default pagination;
